import { render, staticRenderFns } from "./AttachmentWidget.vue?vue&type=template&id=1b2ed152&scoped=true&"
import script from "./AttachmentWidget.vue?vue&type=script&lang=js&"
export * from "./AttachmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentWidget.vue?vue&type=style&index=0&id=1b2ed152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ed152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
